import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-cancellation',
    imports: [CommonModule, RouterModule, MatCardModule],
    templateUrl: './cancellation.component.html',
    styleUrls: ['./cancellation.component.scss']
})
export class CancellationComponent {
  constructor(private router: Router) {}

  showLoginFormOnHome() {
    console.log('Login form requested from navbar - navigating to home with login');
    this.router.navigate(['/'], { queryParams: { showLogin: 'true' } });
  }

  showTripSearchForm() {
    console.log('Trip search form requested from navbar - navigating to home');
    this.router.navigate(['/']);
  }
} 